import { render, staticRenderFns } from "./NurseScheduleForm.vue?vue&type=template&id=5825fed2"
import script from "./NurseScheduleForm.vue?vue&type=script&lang=js"
export * from "./NurseScheduleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports